<template>
  <div class="charge-point">

    <!-- START Charge Point -->
    <div class="row">
      <div class="col-lg-6">
        <div class="card shadow">
          <div class="card-body">
            <card-title icon-image="mdi-ev-station" title="Charge Point" text-color="title" />
            <div class="row mt-2" id="datatable_wrapper">
              <div class="col-lg-12">
                <div class="dataTables_filter text-md-end">
                  <label class="d-inline-flex align-items-center">
                    <b-form-input v-model="filter"
                                  type="search"
                                  placeholder="Search..."
                                  class="form-control form-control-sm ms-2" />
                  </label>
                </div>
              </div>
            </div>

            <div class="charge-point-table">
              <b-table class="datatables text-nowrap" hover
                       :fields="fields" :items="items"
                       :sort-by.sync="sortBy"
                       :sort-desc.sync="sortDesc"
                       :filter="filter"
                       :filter-included-fields="filterOn"
                       @row-clicked="chargePointView"
                       @row-dblclicked="chargePointEdit">
                <template #cell(no)="data">
                  {{ data.index + 1 }}
                </template>
              </b-table>
            </div>

            <div class="row mt-2">
              <div class="col-lg-12 text-align-end">
                <b-button class="w-sm" size="sm" variant="primary" @click="chargePointCreateModal = true">
                  <i class="fas fa-plus icon-padding-right ct-mb-padding-left-25" />
                  <span>Register</span>
                </b-button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-6">
        <div class="card card-height-100 shadow">
          <div class="card-body">
            <card-title icon-image="mdi-database" title="Charge Point Receive Data" text-color="title" />
            <div class="charge-point-data-table">
              <table class="table table-bordered mb-0">
                <thead>
                <tr>
                  <th scope="col" class="w-50">Item</th>
                  <th scope="col" class="w-50">Value</th>
                </tr>
                </thead>
                <tbody v-if="$_utils.isEmpty(item.chargeBoxId)">
                <tr>
                  <td class="text-nowrap" scope="row" colspan="2">Charge Point 를 선택하세요.</td>
                </tr>
                </tbody>
                <tbody v-else>
                <tr v-for="it in jqlApi.schema" v-if="!$_utils.isEmpty(it.key)">
                  <th class="text-nowrap" scope="row">{{ it.label }}</th>
                  <td :style="it.key === 'csr' ? 'text-align: left' : null">{{ item[it.key] }}</td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- END Charge Point -->

    <!-- START Charge Point Create Modal -->
    <b-modal v-model="chargePointCreateModal" centered
             header-bg-variant="primary">
      <template #modal-header>
        <div class="text-white">Charge Point Registration</div>
      </template>
      <div>
        <MDKForm ref="_form" :fields="formFields" :entity="{}" />
      </div>
      <template #modal-footer>
        <div class="w-100 text-align-end">
          <b-button class="w-sm ct-margin-right-100" size="sm" variant="secondary"
                    @click="chargePointCreateModal = false">
            <i class="fas fa-times icon-padding-right ct-mb-padding-left-25" />
            <span class="d-none d-sm-inline-block">Close</span>
          </b-button>
          <b-button class="w-sm" size="sm" variant="primary"
                    @click="createChargePoint">
            <i class="fas fa-plus icon-padding-right ct-mb-padding-left-25" />
            <span>Save</span>
          </b-button>
        </div>
      </template>
    </b-modal>
    <!-- END Charge Point Create Modal -->

    <!-- START Charge Point Edit Modal -->
    <b-modal v-model="chargePointEditModal" centered
             header-bg-variant="primary">
      <template #modal-header>
        <div class="text-white">Charge Point Edit</div>
      </template>
      <div>
        <MDKForm ref="_form" :fields="formFields" :entity="selectedRow ? selectedRow : {}" />
        <div class="mdk-form">
          <div class="mdk-input-area col-sm-12">
            <label class="mdk-input-label">Password</label>
          </div>
          <div class="w-100 row">
            <div class="col">
              <input type="text" autocomplete="off" class="form-control mdk-input-control form-control"
                     v-model="pw" :disabled="!pwChangeMode" />
            </div>
            <div class="col-2 text-align-end">
              <template v-if="pwChangeMode === true">
                <b-button variant="outline-secondary" @click="editCancel()">취소</b-button>
              </template>
              <template v-else-if="pwChangeMode === false">
                <b-button variant="outline-danger" @click="pwChangeMode=true">변경</b-button>
              </template>
            </div>
          </div>
        </div>
      </div>
      <template #modal-footer>
        <div class="w-100 text-align-end">
          <b-button class="w-sm ct-margin-right-100" size="sm" variant="secondary"
                    @click="chargePointEditModal = false">
            <i class="fas fa-times icon-padding-right ct-mb-padding-left-25" />
            <span class="d-none d-sm-inline-block">Close</span>
          </b-button>
          <b-button class="w-sm" size="sm" variant="primary"
                    @click="editChargePoint">
            <i class="fas fa-edit icon-padding-right ct-mb-padding-left-25" />
            <span>Edit</span>
          </b-button>
        </div>
      </template>
    </b-modal>
    <!-- END Charge Point Edit Modal -->

  </div>
</template>

<script>
import CardTitle from '@/views/components/cardTitle.vue';

export default {
  components: { CardTitle },
  data() {
    const _api = this.$_app.service.chargePoint;
    return {
      jqlApi: _api,
      fields: [
        { key: 'no', label: 'No.' },
        { key: 'chargeBoxId', label: 'Charge Box ID', sortable: true },
        { key: 'chargeBoxName', label: 'Charge Box Name', sortable: true },
        { key: 'created', label: '등록일', sortable: true }
      ],
      items: [],
      filter: null,
      filterOn: [],
      sortBy: 'created',
      sortDesc: true,
      formFields: [
        _api.schema.chargeBoxId,
        _api.schema.chargeBoxName
      ],
      chargePointCreateModal: false,
      chargePointEditModal: false,
      selectedRow: null,
      item: {},
      pw: null,
      pwChangeMode: false
    }
  },
  mounted() {
    const vm = this;
    vm.getItems();
  },
  methods: {
    getItems() {
      const vm = this;

      vm.jqlApi.list()
          .then(res => {
            vm.items = res;
          }).catch(err => {
            console.log(err);
          });
    },
    createChargePoint() {
      const vm = this;
      const entity = vm.$refs._form.getUpdatedProperties();

      vm.jqlApi.add(entity)
          .then(res => {
            vm.chargePointCreateModal = false;
            this.$swal('등록 완료', '등록이 완료되었습니다.', 'success')
            vm.getItems();
          }).catch(err => {
            console.log(err)
            this.$swal('등록 실패', '등록에 실패하였습니다.', 'error')
          });
    },
    editChargePoint() {
      const vm = this;
      const entity = vm.$refs._form.getUpdatedProperties();

      if (!this.$_utils.isEmpty(vm.pw)) {
        entity['password'] = vm.pw;
      }

      vm.jqlApi.updateByIdList(vm.selectedRow.id, entity)
          .then(res => {
            vm.chargePointEditModal = false;
            this.$swal('수정 완료', '수정이 완료되었습니다.', 'success')
            vm.getItems();
          }).catch(err => {
            console.log(err)
            this.$swal('수정 실패', '수정이 실패하였습니다.', 'error')
          });
    },
    chargePointView(row) {
      const vm = this;
      vm.selectedRow = row;

      vm.jqlApi.findById(vm.selectedRow.id)
          .then(res => {
            vm.item = Object.assign({}, res);
          }).catch(err => {
            console.log(err)
          });
    },
    chargePointEdit(row) {
      const vm = this;

      vm.pw = null;
      vm.pwChangeMode = false;

      vm.selectedRow = row;
      vm.chargePointEditModal = true;
    },
    editCancel() {
      const vm = this;
      vm.pw = null;
      vm.pwChangeMode = false;
    }
  }
}
</script>
